// Volume Charge Density units with conversion factors to coulomb per cubic meter (C/m³)
export const volumeChargeDensityUnits = [
  { id: 'coulomb-per-cubic-meter', name: 'Coulomb per Cubic Meter', symbol: 'C/m³', plural: 'Coulombs per Cubic Meter', factor: 1 },
  { id: 'coulomb-per-cubic-centimeter', name: 'Coulomb per Cubic Centimeter', symbol: 'C/cm³', plural: 'Coulombs per Cubic Centimeter', factor: 1e6 },
  { id: 'coulomb-per-liter', name: 'Coulomb per Liter', symbol: 'C/L', plural: 'Coulombs per Liter', factor: 1000 },
  { id: 'coulomb-per-cubic-inch', name: 'Coulomb per Cubic Inch', symbol: 'C/in³', plural: 'Coulombs per Cubic Inch', factor: 61023.7440947 },
  { id: 'microcoulomb-per-cubic-meter', name: 'Microcoulomb per Cubic Meter', symbol: 'µC/m³', plural: 'Microcoulombs per Cubic Meter', factor: 1e-6 },
  { id: 'microcoulomb-per-cubic-centimeter', name: 'Microcoulomb per Cubic Centimeter', symbol: 'µC/cm³', plural: 'Microcoulombs per Cubic Centimeter', factor: 1 },
  { id: 'abcoulomb-per-cubic-meter', name: 'Abcoulomb per Cubic Meter', symbol: 'abC/m³', plural: 'Abcoulombs per Cubic Meter', factor: 10 },
  { id: 'abcoulomb-per-cubic-centimeter', name: 'Abcoulomb per Cubic Centimeter', symbol: 'abC/cm³', plural: 'Abcoulombs per Cubic Centimeter', factor: 1e7 },
  { id: 'statcoulomb-per-cubic-meter', name: 'Statcoulomb per Cubic Meter', symbol: 'statC/m³', plural: 'Statcoulombs per Cubic Meter', factor: 3.33564e-10 },
  { id: 'statcoulomb-per-cubic-centimeter', name: 'Statcoulomb per Cubic Centimeter', symbol: 'statC/cm³', plural: 'Statcoulombs per Cubic Centimeter', factor: 3.33564e-4 },
];

export const popularVolumeChargeDensityConversions = [
  { from: 'coulomb-per-cubic-meter', to: 'coulomb-per-cubic-centimeter' },
  { from: 'coulomb-per-cubic-centimeter', to: 'coulomb-per-cubic-meter' },
  { from: 'coulomb-per-cubic-meter', to: 'coulomb-per-liter' },
  { from: 'coulomb-per-liter', to: 'coulomb-per-cubic-meter' },
  { from: 'microcoulomb-per-cubic-meter', to: 'coulomb-per-cubic-meter' },
  { from: 'coulomb-per-cubic-meter', to: 'microcoulomb-per-cubic-centimeter' },
];

export const getUnitById = (id) => volumeChargeDensityUnits.find(unit => unit.id === id);

export const convertVolumeChargeDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert volume charge density units and learn the conversion formula.`;
};
